// export const API_HOST = process.env.REACT_APP_API_PATH || 'https://admin-api-prod.retreatsounds.com/';
export const API_HOST =
  process.env.REACT_APP_API_PATH || 'https://retreat-admin-api-stage.retreatsounds.com/';
export const ASSETS_BASE_URL =
  process.env.ENV === 'PROD'
    ? 'https://public-prod.retreatsounds.com'
    : 'https://public-dev.retreatsounds.com';
